import { apiClient } from './client';

const BASE = '/api/auth';

export const authApi = {
  login: async ({ email, username, password }) => {
    const form = new FormData();
    form.append('username', email || username);
    form.append('password', password);
    form.append('grant_type', 'password');
    const response = await apiClient.post(`${BASE}/login`, form, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    return response.data;
  },

  /** Local session data is cleared by the caller even if the server call fails. */
  logout: async () => {
    try {
      const response = await apiClient.post(`${BASE}/logout`);
      return response.data;
    } catch {
      return { message: 'Logged out' };
    }
  },

  getCurrentUser: async () => {
    const response = await apiClient.get(`${BASE}/users/me`);
    return response.data;
  },

  /** URL of the Diplo SSO login page. */
  getSSORedirect: async () => {
    const response = await apiClient.get(`${BASE}/dipo_sso_redirect`);
    return response.data;
  },
};
